import { FileText } from "lucide-react";
import ResourceCard, { segFromLink } from "@/components/vetting/ResourceCard";

export default function BootcampResources({ data }) {
  const groups = data.items.reduce((acc, it) => {
    (acc[it.original_day] = acc[it.original_day] || []).push(it);
    return acc;
  }, {});
  const whenToUse = [...new Set(data.items.map((i) => i.when_to_use).filter(Boolean))];
  return (
    <div className="space-y-4" data-testid="bootcamp-valuable-resources">
      <div className="rounded-xl bg-[#F7F5EF] border border-[#C9A961]/30 p-4 text-sm text-slate-700 space-y-1">
        <div className="font-serif text-[#0A1F44] text-base">Valuable Resources</div>
        <p>{data.notes[0]}</p>
        {whenToUse.length === 1 && <p className="text-slate-500">{whenToUse[0]}</p>}
      </div>
      {Object.entries(groups).map(([day, items]) => (
        <div key={day} data-testid={`bootcamp-resources-day-${day}`}>
          <div className="text-[12px] uppercase tracking-[0.16em] text-[#8A6D1F] font-semibold mb-2">From Day {day}</div>
          <div className="space-y-2">
            {items.map((it, i) => (
              <div key={i}>
                {it.url ? <ResourceCard seg={segFromLink(it.title, it.url)} testid={`bootcamp-resource-link-${day}-${i}`} /> : (
                  <div className="flex items-start gap-3 rounded-lg border border-slate-200 bg-white p-3">
                    <FileText className="w-4 h-4 text-[#8A6D1F] mt-1 shrink-0" />
                    <span className="flex-1 text-[15px] text-slate-800">{it.title}</span>
                    <span className="text-[11px] font-semibold uppercase tracking-wider px-1.5 py-0.5 rounded bg-amber-50 text-amber-900 border border-amber-200 shrink-0"
                          data-testid={`bootcamp-resource-link-needed-${day}-${i}`}>Link coming</span>
                  </div>
                )}
                {whenToUse.length > 1 && <div className="text-xs text-slate-600 mt-1 px-1">{it.when_to_use}</div>}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
